import { Km3dButtonElement } from './km-3d-button.ts';
import { Km3dElement } from './km-3d.ts';

/** Ulaz za dist/embed/v1.js. Breaking change = v2.js (PLAN §7, Build). */
if (!customElements.get('km-3d')) customElements.define('km-3d', Km3dElement);
if (!customElements.get('km-3d-button')) customElements.define('km-3d-button', Km3dButtonElement);

export { Km3dButtonElement, Km3dElement };
